// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#section-promotions[data-v-9e4b9196]{margin-top:0;padding-top:50px;z-index:1}`, "",{"version":3,"sources":["webpack://./client/views/MainView/MainSectionPromotions.vue"],"names":[],"mappings":"AAGA,qCACE,YAAA,CACA,gBAAA,CACA,SAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
